import styled from 'styled-components'

import Button from '~/components/button'
import SummitSupportSummary from '~/components/summit-support-summary'
import { color, font, device } from '~/styles/utils'

import _ConsentCheckbox from '../consent-checkbox'

// acts as a style override for existing styles
export const Wrapper = styled.div`
  && {
    .totals {
      border-top: 1px solid ${color('lightGrey')};
      padding: 16px 0 0 0;

      &.bottom-border {
        border-bottom: 1px solid ${color('lightGrey')};
        padding-bottom: 16px;
      }
    }

    .amp-apply-promos-box button.apply-promos-button {
      color: ${({ theme }) => theme.color.text.default};
    }

    .amp-order-summary {
      ${font('base')};
      background-color: ${({ theme }) => theme.color.background.default};
      box-shadow: 5px 6px 30px 0 rgba(0, 0, 0, 0.15);

      & > .heading,
      & > .description {
        ${font('bold')};
      }
    }

    @media ${device('notMobile')} {
      margin-top: 50px;
    }
  }
`

export const ViewCartButton = styled(Button)`
  .amp-base && {
    margin: 30px 0;
  }

  i {
    font-size: 14px;
  }
`

export const ConsentCheckbox = styled(_ConsentCheckbox)`
  margin-top: 16px;
`

export const Disclaimer = styled.div`
  margin-top: 36px;

  & p {
    font-size: 11px;
  }
`

export const StyledSummitSupportSummary = styled(SummitSupportSummary)`
  margin-top: 36px;
`
